import styled from 'styled-components';

export const TemplatesListContainer = styled.div`
  min-width: 280px;
  width: 770px;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
`;
